var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    directives: [
      {
        name: "left-to-right-drag",
        rawName: "v-left-to-right-drag",
        value: _vm.type,
        expression: "type",
      },
    ],
    staticClass: "drag-bar",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }